import React, { createContext, useCallback, useMemo, useContext, useState } from 'react';
import { utilityAccountService } from '../services/UtilityAccountService';

export const UtilityContext = createContext();

export const UtilityAccountProvider = props => {
    const [utilityAccounts, setUtilityAccounts] = useState([]);
    const [total, setTotal] = useState(1);
    const [pageCount, setPageCount] = useState(1);

    const getUtilityAccounts = useCallback((sortState, page, pageSize, groupId) => {
        return utilityAccountService
            .getUtilityAccounts(sortState, page, pageSize, groupId)
            .then(res => {
                setUtilityAccounts(res.data);
                setTotal(res.total);
                setPageCount(res.page_count);
            });
    }, []);

    const createUtilityAccount = useCallback((utilityAccount) => {
        return utilityAccountService.createUtilityAccount(utilityAccount);
    }, []);

    const deleteUtilityAccount = useCallback((utilityAccountId) => {
        return utilityAccountService.deleteUtilityAccount(utilityAccountId);
    }, []);

    const updateUtilityAccount = useCallback((utilityAccount) => {
        return utilityAccountService.updateUtilityAccount(utilityAccount);
    }, []);

    const getUtilityAccountRates = useCallback((utilityAccountId) => {
        return utilityAccountService.getUtilityAccountRates(utilityAccountId);
    }, []);

    const updateUtilityAccountRates = useCallback((request) => {
        return utilityAccountService.updateUtilityAccountRates(request);
    }, []);

    const createUtilityAccountRates = useCallback((request) => {
        return utilityAccountService.createUtilityAccountRates(request);
    }, []);

    const deleteUtilityAccountRates = useCallback((utilityAccountRateId) => {
        return utilityAccountService.deleteUtilityAccountRates(utilityAccountRateId);
    }, []);

    const values = useMemo(
        () => ({
            utilityAccounts,
            total,
            pageCount,
            getUtilityAccounts,
            createUtilityAccount,
            deleteUtilityAccount,
            updateUtilityAccount,
            getUtilityAccountRates,
            updateUtilityAccountRates,
            createUtilityAccountRates,
            deleteUtilityAccountRates
        }),
        [utilityAccounts, pageCount, total, getUtilityAccounts, createUtilityAccount, updateUtilityAccount, deleteUtilityAccount, getUtilityAccountRates, updateUtilityAccountRates, createUtilityAccountRates, deleteUtilityAccountRates]
    );

    return <UtilityContext.Provider value={values}>{props.children}</UtilityContext.Provider>;
};

export const useUtilityAccounts = () => {
    const context = useContext(UtilityContext);

    if (context === undefined) {
        throw new Error('useCustomers must be used within a UtilityAccountProvider component.');
    }

    return context;
};
